import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';

import LandingNavbar from './LandingNavbar';
import UserNavbar from './UserNavbar';
import AdminNavbar from './AdminNavbar';

const Navbar = () => {
    const [navbarComponent, setNavbarComponent] = useState(<LandingNavbar />);

    useEffect(() => {
        const checkUserStatus = () => {
            try {
                const storedData = localStorage.getItem('profile');

                if (!storedData) {
                    setNavbarComponent(<LandingNavbar />);
                    return;
                }

                const userProfile = JSON.parse(storedData);
                const userRole = userProfile?.roleType;

;

                if (userRole === 'Admin') {
                    setNavbarComponent(<AdminNavbar />);
                } else if (userRole === 'User') {
                    setNavbarComponent(<UserNavbar />);
                } else {
                    setNavbarComponent(<LandingNavbar />);
                }
            } catch (error) {
                console.error('Error checking user status:', error);
                setNavbarComponent(<LandingNavbar />);
            }
        };

        checkUserStatus();
    }, []);

    return <>{navbarComponent}</>;
};

export default Navbar;
